export enum AiCatalogWriteGateEnum {
  SuperAdmin = 'SuperAdmin',
  CanManageAiBilling = 'CanManageAiBilling',
}
